const COMPACT_SELF_VIEW_MIN_WIDTH = 96;
const COMPACT_SELF_VIEW_SCALE = 0.58;
/**
 * Returns compact self-view dimensions while preserving the source aspect ratio.
 * Thumbnails that are already small are never enlarged by the compact state.
 *
 * @param {number} width - Current thumbnail width.
 * @param {number} height - Current thumbnail height.
 * @param {boolean} compact - Whether compact sizing is active.
 * @returns {ISelfViewDimensions}
 */
export function getSelfViewDimensions(width, height, compact) {
    if (!compact || width <= 0 || height <= 0) {
        return { height, width };
    }
    const compactWidth = Math.min(width, Math.max(COMPACT_SELF_VIEW_MIN_WIDTH, Math.round(width * COMPACT_SELF_VIEW_SCALE)));
    const scale = compactWidth / width;
    return {
        height: Math.round(height * scale),
        width: compactWidth
    };
}
